import { useDialogState } from '~/modules/common/hooks';

export const useToggleCurrencyChangeDialog = () => {
  const {
    open: showCurrencyChangeDialog,
    openDialog: openCurrencyChangeDialog,
    closeDialog: closeCurrencyChangeDialog
  } = useDialogState(false);

  return {
    showCurrencyChangeDialog,
    openCurrencyChangeDialog,
    closeCurrencyChangeDialog
  };
};

export default useToggleCurrencyChangeDialog;
